import { makeStyles, Theme } from "@material-ui/core";

import { getTypeIconColor, RollupsItemType } from "../RollupsList/helpers";

export const useStyles = makeStyles<Theme, { selectedType?: RollupsItemType }>(
  theme => ({
    popover: {
      width: 350,
      zIndex: theme.zIndex.modal
    },

    triggerbutton: {
      minWidth: 223
    },

    triggerLabel: {
      justifyContent: "flex-start"
    },

    triggerStartIcon: {
      color: ({ selectedType }) =>
        selectedType ? getTypeIconColor(selectedType, theme) : undefined
    },

    triggerEndIcon: {
      marginLeft: "auto"
    }
  })
);
